import React from 'react'
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom'
import { BrokerPortalPanel } from './BrokerPortalPanel'
import BrokerPortalContext from '../../context/BrokerPortalContext'
import { BrokerPortalTables } from './BrokerPortalTables'
import { AdminProtectedRoute } from '../Core/Routes/AdminProtectedRoute'
import { AdminRoutes } from '../Admin/AdminRoutes'

export const BrokerRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/portal`}>
        <BrokerPortalPanel />
      </Route>

      <AdminProtectedRoute path={`${path}/admin`}>
        <AdminRoutes />
      </AdminProtectedRoute>

      <Route path={`${path}/accounts`}>
        <BrokerPortalContext>
          <BrokerPortalTables />
        </BrokerPortalContext>
      </Route>

      <Redirect exact from={`${path}`} to={`${path}/portal`} />
    </Switch>
  )
}
